import React from 'react';
import ReactDOM from 'react-dom';
import {ExcursionListApp} from './apps/ExcursionListApp';

let excursionListRoots = document.getElementsByClassName('excursionListRoot');

[].forEach.call(excursionListRoots, function(excursionListRoot) {

    const layout = excursionListRoot.getAttribute('data-layout');
    const travelAreaPreset = excursionListRoot.getAttribute('data-travelarea-preset') || '';
    const travelAreaCountriesPreset = excursionListRoot.getAttribute('data-travelareacountries-preset');
    const travelLabelPreset = excursionListRoot.getAttribute('data-travellabel-preset') || '';
    const seasonPreset = excursionListRoot.getAttribute('data-excursionseason-preset') || '';
    const monthsPreset = excursionListRoot.getAttribute('data-excursionmonths-preset') || '';
    const excursionTypePreset = excursionListRoot.getAttribute('data-excursiontype-preset') || '';
    const excursionCategoryPreset = excursionListRoot.getAttribute('data-excursioncategory-preset') || '';
    const excursionPrintBaseUrl = excursionListRoot.getAttribute('data-excursion-print-base-url') || '';
    const excursionPrintListUrl = excursionListRoot.getAttribute('data-excursion-print-list-url') || '';
    const excursionPrintTeaserUrl = excursionListRoot.getAttribute('data-excursion-print-teaser-url') || '';
    const excursionMapApiUrl = excursionListRoot.getAttribute('data-page-map') || '';
    const favouriteLink = excursionListRoot.getAttribute('data-page-favourites');

    let travelAreaPresetInt = 0;
    if (travelAreaPreset !== '') {
        travelAreaPresetInt = parseInt(travelAreaPreset, 10);
    }

    let travelAreaCountriesPresetArray = [];
    if (travelAreaCountriesPreset && travelAreaCountriesPreset !== '') {
        travelAreaCountriesPresetArray = travelAreaCountriesPreset.split(',').map(travelAreaCountries => parseInt(travelAreaCountries, 10));
    }

    ReactDOM.render(
        <ExcursionListApp
            layout={layout}
            travelAreaPreset={travelAreaPresetInt}
            travelAreaCountriesPreset={travelAreaCountriesPresetArray}
            travelLabelPreset={travelLabelPreset}
            excursionTypePreset={excursionTypePreset}
            excursionCategoryPreset={excursionCategoryPreset}
            seasonPreset={seasonPreset}
            monthsPreset={monthsPreset}
            excursionPrintBaseUrl={excursionPrintBaseUrl}
            excursionPrintListUrl={excursionPrintListUrl}
            excursionPrintTeaserUrl={excursionPrintTeaserUrl}
            favouriteLink={favouriteLink}
            excursionMapApiUrl={excursionMapApiUrl}
        />,
        excursionListRoot
    );
});



// WEBPACK FOOTER //
// ./src/excursionList.js